var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      ref: "label",
      staticClass: "custom-radio radio",
      class: { "is-disabled": _vm.disabled },
      attrs: { disabled: _vm.disabled, tabindex: _vm.disabled ? false : 0 },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") &&
            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
          )
            return null
          $event.preventDefault()
          return _vm.$refs.label.click()
        },
      },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.newValue,
            expression: "newValue",
          },
        ],
        attrs: { type: "radio", disabled: _vm.disabled, name: _vm.name },
        domProps: {
          value: _vm.nativeValue,
          checked: _vm._q(_vm.newValue, _vm.nativeValue),
        },
        on: {
          change: function ($event) {
            _vm.newValue = _vm.nativeValue
          },
        },
      }),
      _c("span", { staticClass: "check" }),
      _c("span", { staticClass: "control-label" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }